export default function SkodaHeader() {
    return (<>
        <nav className="header">
            <div className="header__top">
                <div className="header__top__inner">
                    <a className="header__logo" href="https://www.skoda-auto.pl/" target="_self"></a>
                    <span className="header__motto">Wszystko, co ważne</span>
                </div>
            </div>
            <div className="header__bottom">
                <div className="header__bottom__inner">
                    <a href="https://www.skoda-auto.pl/" target="_self">Przejdź do&nbsp;strony głównej</a>
                </div>
            </div>
        </nav>
    </>);
}
